import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';
import MaterialHandledSave from "./MaterialHandledSave";


const MaterialHandledNew = () => {

    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => {if(!result) {setUser({}); navigate("/Login");}});

    const handleFormSubmit = (e) => {

        let materialhandledid = "";

        let valid = true;

        let material = "";
        if (document.getElementById("materialName").value != '') {
            material = document.getElementById("materialName").value;
        } 
        else {
            valid = false;
            toast.error("Material required");
        }        
        
        let modifiedbyid = user["id"];
        let deleted = "0";

        let instructions = "";
        if (document.getElementById("detailInstructions").value != '') {
            instructions = document.getElementById("detailInstructions").value;
        } 

        if(valid) {
            MaterialHandledSave(materialhandledid, material, modifiedbyid, deleted, instructions);
            toast.success('Success');
            navigate("/MaterialHandled");
        }
    };
    
    document.title = "Material Handled - New";
    return ( 
        <div className="materialHandledNew">
            {user["email"] != undefined && 
                <>
                    <div className="container body-content" style={{marginTop: "25px"}}>
                            
                        <h2>New Material Handled</h2>

                        <form id="materialHandledForm" noValidate="novalidate" autoComplete="off">  

                            <div className="form-group">
                                <label htmlFor="materialName">Material</label>
                                <input className="form-control" id="materialName" name="materialName" type="text" autoComplete="off" />
                            </div>

                            <div className="form-group">
                                <label htmlFor="detailInstructions">Detail Instructions</label>
                                <textarea className="form-control" id="detailInstructions" name="detailInstructions" type="text" cols="20" rows="3" autoComplete="off"></textarea>
                            </div>
                        </form>     
                        <Link to="/MaterialHandled" className="btn btn-primary" style={{marginRight: "4px"}}>Cancel</Link>                       
                        <button onClick={handleFormSubmit} className="btn btn-primary" style={{marginRight: "4px"}}>Save</button>                        
                    </div>
                </>
            }
        </div>
     );
}
 
export default MaterialHandledNew;